export enum FEATURES {
  TEST = "test",
  AGENT = "agent",
}
